import { SvgIcon, SvgIconProps } from '@mui/material';

// black chevron with no background
const ChevronUpIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 18 12"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 12, height: 12, fill: 'none', ...sx }}
      data-testid="chevronIcon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4142 10.9142C16.6332 11.6953 15.3668 11.6953 14.5858 10.9142L9 5.32843L3.41421 10.9142C2.63317 11.6953 1.36684 11.6953 0.585787 10.9142C-0.195262 10.1332 -0.195262 8.86683 0.585787 8.08579L7.58579 1.08579C8.36683 0.304738 9.63317 0.304738 10.4142 1.08579L17.4142 8.08579C18.1953 8.86683 18.1953 10.1332 17.4142 10.9142Z"
        fill="#0B1421"
      />
    </SvgIcon>
  );
};

export default ChevronUpIcon;
